import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const Joiningkits =()=>{
    const CTAContent = [
        {
          pageName: "Joining Kits",
          paragraphitalic: "The Perfect Start to a New Journey",
          paragraphText:
                "Welcome new employees with a thoughtful joining kit that sets the stage for a successful journey. Our customized joining kits are designed to help new hires feel instantly valued, excited, and equipped to dive into their new role. With personalized items and essentials, our kits ensure that the first impression counts.",
          ContactFormName: "Joining Kits",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Branded Stationery & Office Essentials",
          parapgraphItalic: "Elevate Your Workspace with Branded Essentials!",
          sectionparagraphText: (
            <>
              <p>
              Where style meets functionality to create a professional impression. 
                </p>
                <p>
                Transform ordinary office supplies into powerful branding tools with our range of branded stationery and office essentials. From sleek notebooks to custom pens and tech-friendly desk organizers, these items seamlessly combine style and practicality. Ideal for employee onboarding, corporate gifting, or event giveaways, our office essentials ensure your brand leaves a lasting impression. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Joining Kits/Branded Stationery & Office Essentials.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Personalized Welcome Cards & Notes",
          parapgraphItalic: "Welcome with Warmth and Personalization! ",
          sectionparagraphText: (
            <>
              <p>
              Custom welcome cards that create unforgettable first impressions. 
                </p>
                <p>
                Show your appreciation and make newcomers feel valued with personalized welcome cards and notes. Perfect for onboarding new employees, welcoming clients, or celebrating milestones, these thoughtfully designed cards reflect your attention to detail and commitment to building meaningful relationships. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Joining Kits/Personalized Welcome Cards & Notes.webp",
          categoryHeadingLeftSide: "Features That Make It Personal",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Joining Kits/Custom Messaging.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Custom Messaging</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Joining Kits/Elegant Designs.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Elegant Designs</b>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Joining Kits/High-Quality Materials.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>High-Quality Materials</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/Joining Kits/Features That Work as Hard as You Do.jpg",
          NogapHeading: "Features That Work as Hard as You Do",
          Heading: [
            {
              ListHeading: "Customized Designs",
              ListParagraph:
                "Add your logo, tagline, or unique artwork for a professional touch.",
            },
            {
              ListHeading: "Premium Quality",
              ListParagraph:
                "Crafted for durability and daily use, ensuring long-term impact.",
            },
            {
              ListHeading: "Wide Range of Products",
              ListParagraph:
                " Notebooks, pens, folders, sticky notes, and more.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/Joining Kits/Employee Handbook & Useful Guides.jpg",
          NogapHeading: "Employee Handbook & Useful Guides",
          paragraphItalic: "Empower Your Team with Handbooks!",
          paragraphDetail: (
            <>
              <p>
              Informative, engaging, and designed to reflect your company’s culture. 
                </p>
                <p>
            Streamline onboarding and ensure consistency with professionally designed employee handbooks and guides. From outlining policies to showcasing your workplace culture, these handbooks are essential tools for new hires. Add a touch of personalization and creativity to make them engaging and memorable. 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Make an Impact",
          Categories: [
            {
              ServiceImg: "../assests/images/Joining Kits/Tailored Content.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Tailored Content</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Joining Kits/Creative Layouts.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Creative Layouts</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Joining Kits/Custom Branding.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Custom Branding</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>Joining Kits</title>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Make their first day unforgettable with a kit that reflects your company’s culture and commitment to employee satisfaction. 
      </p>
    </>
  );
};

export default Joiningkits;